import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useAuth } from "../../auth/AuthContext";
import { toast } from "react-toastify";
import ShippingFormLayout from "../../Components/ShippingForm/ShippingFormLayout";

export default function SignupDetailsPage() {
  const { currentUser, setUserData } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [initializing, setInitializing] = useState(true);

  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    countryCode: "",
    state: "",
    city: "",
    address: "",
    postalCode: "",
    notes: "",
  });

  useEffect(() => {
    if (!currentUser) return;

    const loadData = async () => {
      try {
        const snap = await getDoc(doc(db, "users", currentUser.uid));
        if (snap.exists()) {
          const data = snap.data().shippingInfo || {};
          setForm({
            fullName: data.fullName || "",
            phone: data.phone || "",
            countryCode: data.countryCode || "",
            state: data.state || "",
            city: data.city || "",
            address: data.address || "",
            postalCode: data.postalCode || "",
            notes: data.notes || "",
          });
        }
      } catch (err) {
        console.error("Failed to load existing shipping info:", err);
      } finally {
        setInitializing(false);
      }
    };

    loadData();
  }, [currentUser]);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentUser) {
      toast.error("Please sign in first");
      return;
    }

    setLoading(true);
    try {
      await updateDoc(doc(db, "users", currentUser.uid), {
        shippingInfo: { ...form },
        signUpStage: "complete",
        updatedAt: new Date(),
      });

      setUserData((prev) => ({
        ...prev,
        shippingInfo: { ...form },
        signUpStage: "complete",
      }));

      toast.success("Details saved ✅");
      navigate("/cart");
    } catch (err) {
      console.error("Firestore error:", err);
      toast.error("Failed to save details: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (initializing) {
    return <div style={{ padding: 40, textAlign: "center" }}>Loading…</div>;
  }

  return (
    <div
      style={{
        minHeight: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f9f9f9, #f0f4f7)",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          width: "100%",
          maxWidth: 520,
          padding: "10px 0",
          textAlign: "center",
        }}
      >
<ShippingFormLayout
  title="Shipping Details"
  subtitle="Enter your shipping details to continue to checkout."
  form={form}
  onChange={handleChange}
  onSubmit={handleSubmit}
  saving={loading}
  submitText="Save Details"
  savingText="Saving..."
  centered
  card
/>      </div>
    </div>
  );
}